import {UserContract} from 'app/components/entities/user/model';
import {apiClient} from 'app/components/shared';

export class UserApi {
  static async getTeamProfile(teamId: string): Promise<UserContract.Profile> {
    return apiClient.get<UserContract.Profile>(`front/api/v1t/team/${teamId}/users/me`);
  }

  static async getAgreement(): Promise<UserContract.AgreementDetails> {
    return apiClient.get<UserContract.AgreementDetails>(`/front/api/v1/users/agreement`);
  }

  static async getPublicAgreement(): Promise<UserContract.AgreementDetails> {
    return apiClient.get<UserContract.AgreementDetails>(`/front/api/v1/agreement`);
  }

  static async getPolicy(): Promise<UserContract.Policy> {
    return apiClient.get<UserContract.Policy>(`/front/api/v1/users/policy`);
  }

  static async acceptAgreement(id: string, time: number): Promise<void> {
    return apiClient.post<void, UserContract.Agreement>(`/front/api/v1/users/agreement`, {
      AgreementID: id,
      AgreementTime: time,
    });
  }
}
